@if (contest && contest.closing_date === null && contest.decision_table) {
  <app-new-proposal-blank [contest]=contest
    [decision_table]="contest.decision_table" [framework]="contest.decision_table.framework">
  </app-new-proposal-blank>
}